<template>
  <div class="w-realData" :class="{'pc-realData':!isMobile}">
    <div class="realData">
      <div class="page-header">
        <div class="header">
          <p class="title">
            实时数据
          </p>
          <div class="state" :class="{'state-off':deviceInfo.device_status !=='在线'}"></div>
          <div class="device-statue">
            {{deviceInfo.device_status}}
          </div>
          <template v-if="realData.alarm">
            <div class="state state-error"></div>
            <div class="device-statue" style="overflow: hidden;">
              {{realData.alarm}}
            </div>
          </template>
        </div>
        <div class="option-select">
          <div class="charts-input">
            <el-button @click="loadFreashData()" type="primary" :loading="loading.realData">刷新数据</el-button>
          </div>
        </div>
      </div>
      <div class="option-select">
        <div class="his-data">
          <el-button @click="toogleDrop">{{dropList.show?'关闭':'展开历史数据列表'}}</el-button>
          <div class="data-time">
            {{tableData.time_stamp}}
          </div>
        </div>
        <div class="drop-list">
          <dropList :show="dropList.show" :data="hisDataList"  @selectItem="selectItem" @selectDate="selectDate" type="ALLOCATE"></dropList>
        </div>
      </div>
      <WxLoading :show="loading.auto"></WxLoading>
      <div v-if="loading.realData" class="vfor-list">
        <el-card class="box-card vfor-card no-padding">
          <loading></loading>
        </el-card>
      </div>
      <div v-else class="m-card">
        <div class="card-body water-table">
          <div>
            <table>
              <tr>
                <th colspan="2">
                  <div class="setting-th">
                    <span>设定值</span>
                    <div v-if="deviceInfo.category==='配煤'">
                      <el-button v-if="edit.type==='CLOSE'" @click="openEdit" type="success" plain
                                 :size="isMobile?'mini':'small'">编辑
                      </el-button>
                      <el-button v-if="edit.type==='OPEN'" @click="saveConf" :loading="loading.confData" type="success"
                                 :size="isMobile?'mini':'small'">{{loading.confData?'正在通信':'保存'}}
                      </el-button>
                      <el-button v-if="edit.type==='OPEN'" @click="closeEdit" type="text"
                                 :size="isMobile?'mini':'small'">取消
                      </el-button>
                    </div>

                  </div>

                </th>
              </tr>
              <template v-if="deviceInfo.category==='配煤'">
                <tr>
                  <td>原料/煤料</td>
                  <td v-if="loading.confData">正在通信</td>
                  <td v-else-if="edit.type==='CLOSE'">{{confData['煤料设定标准份数']}}</td>
                  <td v-else>
                    <el-input size="mini" v-model.number="confData['煤料设定标准份数']"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>--</td>
                  <td>--</td>
                </tr>
                <tr>
                  <td>--</td>
                  <td>--</td>
                </tr>
              </template>
              <template v-if="deviceInfo.category==='配水'">
                <template v-for="item in tableData.sdz">
                  <tr>
                    <td>{{item.key}}</td>
                    <td>{{item.value}}</td>
                  </tr>
                </template>
              </template>

              <tr>
                <th colspan="2">运行状态</th>
              </tr>
              <template v-if="deviceInfo.category==='配煤'">
                <tr>
                  <td>原料带</td>
                  <td>{{tableData.yxzt['原料带']}}</td>
                </tr>
                <tr>
                  <td>煤皮秤</td>
                  <td>{{tableData.yxzt['煤皮秤']}}</td>
                </tr>
              </template>
              <template v-if="deviceInfo.category==='配水'">
                <template v-for="(value, key) in tableData.yxzt">
                  <tr>
                    <td>{{key}}</td>
                    <td>{{value}}</td>
                  </tr>
                </template>
              </template>

            </table>
          </div>
          <div>
            <table>
              <tr>
                <th colspan="2">实时值</th>
              </tr>
              <template v-if="deviceInfo.category==='配煤'">
                <tr>
                  <td>原料Kg/s</td>
                  <td>{{tableData.fAi['原料流量Kg/s']}}</td>
                </tr>
                <tr>
                  <td>煤料Kg/s</td>
                  <td>{{tableData.fAi['煤料流量Kg/s']}}</td>
                </tr>
                <tr>
                  <td>原料/煤料</td>
                  <td>{{tableData.fhb['原煤时累计比']}}</td>
                </tr>
                <tr>
                  <td>煤秤电机Hz</td>
                  <td>{{tableData.fAi['煤料电机Hz']}}</td>
                </tr>
                <tr>
                  <td>煤秤Kg</td>
                  <td>{{tableData.fmc['煤秤重量KG']}}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                  <td></td>
                </tr>

              </template>
              <template v-if="deviceInfo.category==='配水'">
                <template v-for="item in tableData.fAi">
                  <tr>
                    <td>{{item.key}}</td>
                    <td>{{item.value}}</td>
                  </tr>
                </template>
              </template>
            </table>
          </div>
          <div>
            <table>
              <tr>
                <th colspan="2">时累计</th>
              </tr>
              <tr>
                <td>原料T</td>
                <td>{{tableData.fHour['原料时累计T']}}</td>
              </tr>
              <tr v-if="deviceInfo.category==='配煤'">
                <td>煤料T</td>
                <td>{{tableData.fHour['煤料时累计T']}}</td>
              </tr>
              <tr v-if="deviceInfo.category==='配水'">
                <td>加水比例%</td>
                <td>{{tableData.fhb['加水时比例%']}}</td>
              </tr>
              <tr>
                <th colspan="2">日累计</th>
              </tr>
              <tr>
                <td>原料T</td>
                <td>{{tableData.fDay['原料日累计T']}}</td>
              </tr>
              <template v-if="deviceInfo.category==='配煤'">
                <tr>
                  <td>煤料T</td>
                  <td>{{tableData.fDay['煤料日累计T']}}</td>
                </tr>
                <tr>
                  <td>原料/煤料%</td>
                  <td>{{tableData.fdb['原煤日累计比']}}</td>
                </tr>
              </template>
              <template v-if="deviceInfo.category==='配水'">
                <tr>
                  <td>加水比例%</td>
                  <td>{{tableData.fdb['加水日比例%']}}</td>
                </tr>
              </template>

            </table>
          </div>
        </div>
      </div>

    </div>
    <Mconfirm v-if="isMobile" :loading="loading.confData" :show="edit.type==='OPEN'" @define="saveConf"
              @cancel="closeEdit"></Mconfirm>
  </div>

</template>

<script>
  import loading from "../../components/common/loading.vue";
  import WxLoading from "../../components/tempControl/wxLoading"
  import dropList from "../../components/tempControl/dropTimePicker"
  import Mconfirm from "../../components/tempControl/Mconfirm"
  import Lib from "../../lib/lib";
  import moment from 'moment'
  import {mapState} from "vuex";

  export default {
    name: "W_realData",
    components: {
      loading,
      Mconfirm,
      WxLoading,
      dropList
    },
    computed: {
      ...mapState({
        isMobile: state => state.isMobile,
        deviceInfo: state => state.deviceInfo,
        userInfo: state => state.userInfo,
        config: state => state.config
      })
    },
    data() {
      return {
        option: {
          sys_alias: 1,
          date: moment()

        },
        sys_alias: [],
        realData: {},
        tableData: {},
        realDataTh: {
          fAi: "实时值",
          fHour: "时累计",
          fDay: "日累计",
          fmc: "设定值"
        },
        edit: {
          type: "CLOSE"
        },
        loading: {
          realData: true,
          confData: true,
          auto: false
        },
        confData: {},
        dropList: {
          show: false
        },
        hisDataList: [],
        hisData: [],
        // 定时任务id
        id_of_setinterval: "",
      };
    },
    created() {
      this.getConf(true)
      this.loadHisData()
    },
    mounted() {
      Lib.M.selectInputFoc();
      this.timingLoadRealData('OPEN')

      // this.$store.dispatch("toggleSide",false);
    },
    beforeDestroy() {
      this.timingLoadRealData('CLOSE')
    },
    methods: {
      toogleDrop(){
        if(this.dropList.show){
          this.loadRealData(true);
        }
        this.dropList.show=!this.dropList.show;

      },
      selectItem(data, dataList, index){
        this.tableData=this.hisData[index];
      },
     selectDate(time){
       this.option.date=time.day;
       this.loadHisData()
     },
      // 定时任务
      timingLoadRealData(type) {
        if (type === "OPEN") {
          this.id_of_setinterval = setInterval(() => {
            this.loadRealData(false, true);
          }, this.config.refreshInterval ? this.config.refreshInterval : 30000);
        } else {
          clearInterval(this.id_of_setinterval);
        }
      },
      loadFreashData() {
        this.loadRealData(false);
        this.getConf(false);
      },
      loadRealData(is_cache, is_auto) {
        if (!is_auto) {
          this.loading.realData = true;
        } else {
          this.loading.auto = true;
        }


        let params = {
          data_type: "realData",
          sys_alias: 1,
          device_id: this.deviceInfo.device_id,
          is_cache: is_cache
        };
        if (this.userInfo.identity === "USER") {
          params.auth_token = this.userInfo.token;
        } else {
          params.customer_token = this.userInfo.token;
        }
        Lib.api.loadDeviceData(params, data => {
          if (data.status_code === "SUCCEEDED") {
          }
          if (data.payload.data) {
            let payload = JSON.parse(data.payload.data);
            this.realData = payload;
            this.tableData = {
              fAi: payload.fAi,
              fDay: payload.fDay,
              fHour: payload.fHour,
              fdb: payload.fdb,
              fhb: payload.fhb,
              fmc: payload.fmc,
              sdz: payload.sdz,
              yxzt: payload.yxzt ? payload.yxzt : {},
              time_stamp: payload.date
            };
            this.loading.realData = false;
            this.loading.auto = false;

          } else {
          }
        });
      },
      openEdit() {
        this.edit.type = 'OPEN';
        this.getConf(false);
      },
      closeEdit() {
        this.edit.type = 'CLOSE';
        // this.getConf(true);
      },

      getConf(is_cache) {
        if (this.deviceInfo.category === '配水') {
          this.loadControlConf(is_cache)
        } else if (this.deviceInfo.category === '配煤') {
          this.loadStandConf(is_cache)

        }

      },
      saveConf() {
        if (this.deviceInfo.category === '配水') {
          this.saveControlConf()
        } else if (this.deviceInfo.category === '配煤') {
          this.saveStandConf()

        }
      },
      //获取标准参数
      loadStandConf(is_cache) {
        this.loading.confData = true;
        let params = {
          conf_type: "standard",
          sys_alias: this.option.sys_alias * 1,
          device_id: this.deviceInfo.device_id,
          is_cache: is_cache,
          payload: {
            devNo: this.option.sys_alias * 1,
            type: 30//???
          }
        };
        if (this.userInfo.identity === "USER") {
          params.auth_token = this.userInfo.token;
        } else {
          params.customer_token = this.userInfo.token;
        }
        Lib.api.loadDeviceConf(params, data => {
          this.loading.confData = false;
          // 确认数据是否更新，否则只读
          if (data.status_code === "SUCCEEDED") {

          } else {
            this.$message({
              message: "网络连接超时：" + data.msg,
              type: "warning"
            });
            if (!this.isMobile) {
              this.$notify.info({
                title: "温馨提示",
                message: "无法连接设备时，无法进行参数修改操作",
                duration: 3000,
                offset: 60
              });
            }
            this.closeEdit();
          }
          if (data.payload && data.payload.data) {
            this.confData = JSON.parse(data.payload.data)
          }
        });
      },
      saveStandConf() {
        this.loading.confData = true;
        let payload = this.confData;
        payload.devNo = this.option.sys_alias * 1;
        payload = JSON.stringify(payload);
        let params = {
          conf_type: "standard",
          sys_alias: this.option.sys_alias.toString(),
          device_id: this.deviceInfo.device_id,
          payload: payload
        };
        if (this.userInfo.identity === "USER") {
          params.auth_token = this.userInfo.token;
        } else {
          params.customer_token = this.userInfo.token;
        }
        Lib.api.setDeviceConf(params, data => {
          if (data.status_code === "SUCCEEDED") {
            this.$message.success("修改成功");
            this.getConf(false);
            this.closeEdit();
          } else {
            this.$message.error(`修改失败：${data.msg}`);
            this.loading.confData = false;
          }
        });
      },
      saveControlConf() {
        this.loading.confData = true;
        let payload = this.confData;
        payload.devNo = this.option.sys_alias * 1;
        payload = JSON.stringify(payload);
        let params = {
          conf_type: "control",
          sys_alias: this.option.sys_alias.toString(),
          device_id: this.deviceInfo.device_id,
          payload: payload
        };
        if (this.userInfo.identity === "USER") {
          params.auth_token = this.userInfo.token;
        } else {
          params.customer_token = this.userInfo.token;
        }
        Lib.api.setDeviceConf(params, data => {
          if (data.status_code === "SUCCEEDED") {
            this.$message.success("修改成功");
            this.getConf(false);
            this.closeEdit();
          } else {
            this.$message.error(`修改失败：${data.msg}`);
            this.loading.confData = false;
          }
        });
      },
      //历史数据
      loadHisData() {
        let params = {
          device_id: this.deviceInfo.device_id,
          data_type: "hisDatap",
          sys_alias: this.option.sys_alias,
          page_size: 300,
          order: "asc"
        };
        if (this.option.date) {
          params.begin = moment(this.option.date).format("YYYY-MM-DD 00:00:00");
          params.end = moment(this.option.date)
            .add(1, "day")
            .format("YYYY-MM-DD 00:00:00");
        }
        if (this.userInfo.identity === "USER") {
          params.auth_token = this.userInfo.token;
        } else {
          params.customer_token = this.userInfo.token;
        }
        Lib.api.loadDeviceData(params, data => {
          this.loadRealData(true);

          if (data.status_code === "SUCCEEDED") {
            if (data.payload && data.payload.length > 0) {
              this.hisData = this.dealHisData(data.payload);
              this.hisDataList = this.hisData.map(obj=>{
                obj.fAi.forEach((aiObj,i)=>{
                  let newObj={};
                  newObj[aiObj.key]=aiObj.value;
                  obj["fAi_"+i] = newObj;
                });
                obj.fAi = null;
                obj.sdz.forEach((sdzObj,i)=>{
                  let newObj={};
                  newObj[sdzObj.key]=sdzObj.value;
                  obj["sdz_"+i] = newObj;
                });
                obj.sdz = null;
                return obj;
              });
            } else {

            }
          } else {
            console.error("历史数据接口：" + data.msg);

          }
        });

      },
      dealHisData(data) {
        let arr = [];
        data.forEach((v) => {
          v.data = JSON.parse(v.data);
          arr.push({
            fAi: v.data.fAi,
            fDay: v.data.fDay,
            fHour: v.data.fHour,
            fdb: v.data.fdb,
            fhb: v.data.fhb,
            fmc: v.data.fmc,
            sdz: v.data.sdz,
            yxzt: v.data.yxzt ? v.data.yxzt : {},
            time_stamp: v.data.date

          })
        })
        return arr

      },

      //  控制参数
      loadControlConf(is_cache) {
        this.loading.confData = true;
        let params = {
          conf_type: "control",
          sys_alias: this.option.sys_alias,
          device_id: this.deviceInfo.device_id,
          is_cache: is_cache
        };
        if (this.userInfo.identity === "USER") {
          params.auth_token = this.userInfo.token;
        } else {
          params.customer_token = this.userInfo.token;
        }
        Lib.api.loadDeviceConf(params, data => {
          this.loading.confData = false;
          // 确认数据是否更新，否则只读
          if (data.status_code === "SUCCEEDED") {

          } else {
            this.$message({
              message: "网络连接超时：" + data.msg,
              type: "warning"
            });
            if (!this.isMobile) {
              this.$notify.info({
                title: "温馨提示",
                message: "无法连接设备时，无法进行参数修改操作",
                duration: 3000,
                offset: 60
              });
            }
            this.closeEdit();
          }
          if (data.payload && data.payload.data) {
            this.confData = JSON.parse(data.payload.data);
          }
        });
      },

    }
  };
</script>

<style scoped>
  .set-option {
    display: flex;
    justify-content: space-between;
  }
  .his-data {
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .data-time {
    color: red;
  }

  .m-card {
    border: none;
    box-shadow: none;
  }

  .header {
    display: flex;
    justify-content: left;
    align-items: center;
    margin-bottom: 0px;
    font-size: 0.23rem;
    color: #0056b8;
  }

  .chars-header {
    font-size: 18px;
    display: flex;
    justify-content: space-between;
  }

  .state {
    margin-left: 10px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #39d649;
  }

  .state-off {
    background: gray;
  }

  .state-error {
    background: red;
  }

  .device-statue {
    font-size: 0.18rem;
    color: #000;
    margin-left: 15px;
  }

  .box-card {
    margin-bottom: 16px;
  }

  .box-card .chars-header {
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 600;
  }

  .water-table {
    display: flex;
    padding: 0px 0;
  }

  .page-header .option-select {
    align-items: center;
  }

  .water-table table {
    border: 1px solid #e8e8e8;
    border-right: 0;
    border-bottom: 0;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    text-align: left;
    border-radius: 4px 4px 0 0;
  }

  .water-table tr th {
    border-bottom: 1px solid #e8e8e8;
    background: #2378dc;
    color: #fff;
    line-height: 1.4;
  }

  .setting-th {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .water-table tr td, .water-table tr th {
    padding: 8px 8px;
    word-break: break-all;
    border-right: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
    font-size: 16px;
  }

  .pc-realData .water-table tr td, .pc-realData .water-table tr th {
    padding: 8px 8px;
    font-size: 22px;
    line-height: 2;
  }

  .pc-realData .water-table tr th {
    line-height: 2;
  }

  .pc-realData .header {
    font-size: .3rem;
  }

  @media screen and (max-width: 600px) {
    .header {
      margin-bottom: 10px;
    }

    .device-statue {
      font-size: 16px;
      margin-left: 5px;
    }

    .state {
      margin-left: 10px;
    }

    .water-table {
      display: block;
      padding: 0px 0;
    }

    .water-table > div {
      padding: 0px 0;
    }

    .page-header .option-select {
      margin: 0 -10px;
      align-items: center;
    }



  }
</style>
<style>
  .w-realData .drop-list th, .w-realData .drop-list td {
    width: 90px;

  }

</style>



// WEBPACK FOOTER //
// realData.vue?34c83f82